import { sendSoundEvents } from './soundEvents/eventDispatcherApi'
// import logger, { TAG_NAMES } from 'utils/Logger'

const sendEvents = function (events) {
//   sendTrackerEvents(events)
  sendSoundEvents(events)
//   logger(TAG_NAMES.EVENTS, events?.name || 'Events with No name', {
//     data: events
//   })
}

export { sendEvents}
